export type OptionType = {
  value: string | number;
  label: string;
  key?: string;
};

export const getInitialOptionValue = <T extends string | OptionType | number>(option: T | undefined): string | number | undefined => {
  if (!option) return undefined;
  if (typeof option === 'object' && 'value' in option) return option.value;
  if (typeof option === 'string' || typeof option === 'number') return option;
  return undefined;
};

export const findOptionByValue = <T extends string | OptionType | number>(
  options: T[],
  value: string | number | undefined
): T | undefined => {
  if (value === undefined) return undefined;
  return options.find((option) => {
    const optionValue = getInitialOptionValue(option);
    return optionValue === value;
  });
};

export const hasOptionWithValue = <T extends string | OptionType | number>(options: T[], value: string | number | undefined): boolean => {
  return findOptionByValue(options, value) !== undefined;
};
